import { isNull, get } from "lodash"
import locales from "./../../../content.json"

export const checkIsValidDietType = data => {
    return validateDietTypeStep(get(data, ["dietType", "value"], "")) && !data.dietType.isValid
}

export const validateDietTypeStep = value => {
    return !isNull(value)
}

export const dietTypeData = {
    food: {
        value: "food",
        title: locales[window.userLang].all_food,
        icon: "img/icon-food.png"
    },
    veget: {
        value: "veget",
        title: locales[window.userLang].vegetarian,
        icon: "img/icon-veget.png"
    },
    vegan: {
        value: "vegan",
        title: locales[window.userLang].vegan,
        icon: "img/icon-vegan.png"
    },
    keto: {
        value: "keto",
        title: locales[window.userLang].keto,
        icon: "img/icon-keto.png"
    },
}

export const defaultFasting = false